<template>
  <!-- Loading Overlay -->
  <div v-if="loading" class="loading-overlay">
    <div class="box has-text-centered">
      <span class="icon is-large has-text-danger">
        <i class="fas fa-fire fa-2x"></i>
      </span>

      <p class="title is-5 mt-3">กำลังโหลดข้อมูล Hotspots...</p>

      <progress class="progress is-danger is-small mt-4" max="100"></progress>

      <p class="is-size-7 has-text-grey mt-2">กำลังดึงข้อมูลจาก NASA FIRMS</p>
    </div>
  </div>

  <l-map
    v-if="province && provinces[province]"
    :zoom="8"
    :center="provinces[province]?.center || defaultCenter"
    style="height: 600px"
  >
    <l-tile-layer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

    <l-circle-marker
      v-for="(fire, i) in hotspots"
      :key="i"
      :lat-lng="[fire.latitude, fire.longitude]"
      :radius="6"
      :color="getColor(fire.confidence)"
    >
      <l-popup>
        🔥 Brightness: {{ fire.brightness }} <br />
        🛰 Satellite: {{ fire.satellite }}
      </l-popup>
    </l-circle-marker>
  </l-map>

  <!-- Hotspot Table -->
  <div class="box mt-5">
    <div class="level">
      <div class="level-left">
        <h3 class="title is-5">
          🔥 รายการจุดความร้อน ({{ hotspots.length }} จุด)
        </h3>
      </div>
    </div>

    <div class="table-container">
      <table
        class="table is-striped is-hoverable is-fullwidth is-bordered is-narrow"
      >
        <thead>
          <tr class="has-background-danger-light">
            <th>#</th>
            <th>Latitude</th>
            <th>Longitude</th>
            <th>Brightness</th>
            <th>Satellite</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="(fire, index) in hotspots" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ fire.latitude.toFixed(4) }}</td>
            <td>{{ fire.longitude.toFixed(4) }}</td>
            <td>
              <span class="tag is-danger is-light">
                {{ fire.brightness }}
              </span>
            </td>
            <td>{{ fire.satellite }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
/* global defineProps */
import { ref, watch } from "vue";
import {
  LMap,
  LTileLayer,
  LCircleMarker,
  LPopup,
} from "@vue-leaflet/vue-leaflet";
import { provinces } from "../config/provinces.js";
import { fetchHotspots } from "../api/firms.js";

const props = defineProps(["province"]);

const defaultCenter = [16.8, 100.2];

const hotspots = ref([]);
const loading = ref(false);

async function loadData() {
  loading.value = true;
  hotspots.value = await fetchHotspots(props.province);
  loading.value = false;
}

watch(() => props.province, loadData, { immediate: true });

// auto refresh ทุก 5 นาที
setInterval(loadData, 5 * 60 * 1000);

function getColor(confidence) {
  if (confidence === "high") return "red";
  if (confidence === "nominal") return "orange";
  return "yellow";
}

console.log("Province:", props.province);
console.log("Provinces object:", provinces);
</script>

<style scoped>
.map-wrapper {
  position: relative;
}

.loading-overlay {
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.85);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 2rem;
  z-index: 1000;
}
</style>
